export const LABELS = {
    unspecified: 'サイズ無指定',
    click_post: 'クリックポスト',
    smaller_or_eq_than_100_size: '〜100',
    size_101_to_140: '101〜140',
    above_140_size: '141〜',
}